import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Avatar,
  Menu,
  MenuItem,
  Drawer,
  List,
  ListItemIcon,
  ListItemText,
  Divider,
  ListItemButton, // ✅ Added this import
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import PeopleIcon from "@mui/icons-material/People";
import BuildIcon from "@mui/icons-material/Build";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import LogoutIcon from "@mui/icons-material/Logout";
import StoreIcon from "@mui/icons-material/Store";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import {
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { auth, firestore } from "../../../firebase";
import logo from "../../../OV-WarrantyMS.png";

function AdminNavBar() {
  const [userData, setUserData] = useState(null);
  const [userRole, setUserRole] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setUserData(user);
        try {
          const q = query(
            collection(firestore, "UserProfileMaster"),
            where("email", "==", user.email)
          );
          const snapshot = await getDocs(q);
          if (!snapshot.empty) {
            const role = snapshot.docs[0].data().role || "unknown";
            setUserRole(role);
            sessionStorage.setItem("userRole", role);
          } else {
            console.warn(`User profile not found for email: ${user.email}`);
            setUserRole("unknown");
            sessionStorage.removeItem("userRole");
          }
        } catch (error) {
          console.error("Error fetching user role:", error);
          setUserRole("error");
          sessionStorage.removeItem("userRole");
        }
      } else {
        setUserData(null);
        setUserRole("");
        sessionStorage.removeItem("userRole");
      }
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("userRole");
    signOut(auth).then(() => navigate("/"));
    setAnchorEl(null);
    setDrawerOpen(false);
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleDrawerNavigation = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  const appLabel = "Warranty";

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          background: "linear-gradient(to right, #6A5ACD, #FF69B4)",
        }}
      >
        {/* --- MODIFICATION: Removed justifyContent --- */}
        <Toolbar>
          <IconButton color="inherit" onClick={toggleDrawer(true)} edge="start">
            <MenuIcon />
          </IconButton>

          {/* --- MOVED & MODIFIED THIS BLOCK --- */}
          <Box
            onClick={() => navigate("/")}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              cursor: "pointer",
              ml: 2,
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontFamily: "'Unbounded', cursive",
                fontWeight: 900,
                color: '#1c1400',
                fontSize: '1.1rem',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                lineHeight: 1,
              }}
            >
              Aalay<span style={{ color: '#f59e0b', fontSize: '1.4rem' }}>.</span>
            </Typography>

            <Typography
              variant="caption"
              component="div"
              sx={{
                fontStyle: 'italic',
                color: '#1c1400',
                opacity: 0.85,
                fontSize: '0.7rem',
                mt: 0.2,
                fontFamily: 'inherit',
                textTransform: 'none',
              }}
            >
              Intelligent Operations by OmneVu.com
            </Typography>
          </Box>
          {/* --- END MOVED BLOCK --- */}

          {/* --- ADDED: Spacer Box --- */}
          {/* This pushes the user avatar to the right */}
          <Box sx={{ flexGrow: 1 }} />
          {/* --- END SPACER --- */}

          <Box>
            {userData ? (
              <>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    sx={{ p: 0 }}
                  >
                    <Avatar sx={{ bgcolor: "secondary.main" }}>
                      {userData.displayName?.charAt(0).toUpperCase() ||
                        userData.email?.charAt(0).toUpperCase() ||
                        "U"}
                    </Avatar>
                  </IconButton>
                  <Typography
                    variant="caption"
                    sx={{ lineHeight: 1, color: "white" }}
                  >
                    {appLabel}
                  </Typography>
                </Box>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem disabled sx={{ opacity: 1 }}>
                    {userData.email}
                  </MenuItem>
                  <MenuItem disabled sx={{ opacity: 1 }}>
                    Role: {userRole}
                  </MenuItem>
                  <Divider />

                  {userRole === "admin" && (
                    <Box>
                      <MenuItem
                        onClick={() => {
                          navigate("/user-management");
                          setAnchorEl(null);
                        }}
                      >
                        <ListItemIcon>
                          <PeopleIcon fontSize="small" />
                        </ListItemIcon>{" "}
                        User Management
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          navigate("/warranty_list");
                          setAnchorEl(null);
                        }}
                      >
                        <ListItemIcon>
                          <BuildIcon fontSize="small" />
                        </ListItemIcon>{" "}
                        Warranty List
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          navigate("/complaints_list");
                          setAnchorEl(null);
                        }}
                      >
                        <ListItemIcon>
                          <ReportProblemIcon fontSize="small" />
                        </ListItemIcon>{" "}
                        Complaints
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          navigate("/addshop");
                          setAnchorEl(null);
                        }}
                      >
                        <ListItemIcon>
                          <StoreIcon fontSize="small" />
                        </ListItemIcon>{" "}
                        Manage B
                      </MenuItem>
                      <Divider />
                    </Box>
                  )}

                  <MenuItem onClick={handleLogout}>
                    <ListItemIcon>
                      <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    Logout
                  </MenuItem>
                </Menu>
              </>
            ) : (
              <Button color="inherit" onClick={() => navigate("/login")}>
                Login
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      <Toolbar />

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <Box
          sx={{
            width: 270,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List sx={{ flexGrow: 1 }}>
            <ListItemButton onClick={() => handleDrawerNavigation("/")}>
              <ListItemIcon>
                <img
                  src={logo}
                  alt="Logo"
                  style={{ height: 28, width: "auto" }}
                />
              </ListItemIcon>
              <ListItemText
                primary="Home"
                primaryTypographyProps={{ fontWeight: 500 }}
              />
            </ListItemButton>
            <Divider />

            {userData && userRole === "admin" && (
              <>
                <ListItemButton
                  onClick={() => handleDrawerNavigation("/user-management")}
                >
                  <ListItemIcon>
                    <PeopleIcon />
                  </ListItemIcon>
                  <ListItemText primary="User Management" />
                </ListItemButton>
                <ListItemButton
                  onClick={() => handleDrawerNavigation("/warranty_list")}
                >
                  <ListItemIcon>
                    <BuildIcon />
                  </ListItemIcon>
                  <ListItemText primary="Warranty List" />
                </ListItemButton>
                <ListItemButton
                  onClick={() => handleDrawerNavigation("/complaints_list")}
                >
                  <ListItemIcon>
                    <ReportProblemIcon />
                  </ListItemIcon>
                  <ListItemText primary="Complaints" />
                </ListItemButton>
                <Divider sx={{ my: 1 }} />
              </>
            )}
          </List>

          {userData && (
            <Box sx={{ p: 2 }}>
              <Divider />
              <Typography
                variant="caption"
                sx={{
                  color: "text.secondary",
                  mt: 1.5,
                  display: "block",
                  wordBreak: "break-word",
                }}
              >
                Logged in as: {userData.email} <br /> Role: {userRole}
              </Typography>
              <ListItemButton
                onClick={handleLogout}
                sx={{
                  mt: 1.5,
                  backgroundColor: (theme) => `${theme.palette.error.light}40`,
                  "&:hover": {
                    backgroundColor: (theme) =>
                      `${theme.palette.error.light}60`,
                  },
                  borderRadius: 1,
                }}
              >
                <ListItemIcon>
                  <LogoutIcon color="error" />
                </ListItemIcon>
                <ListItemText
                  primary="Logout"
                  primaryTypographyProps={{
                    fontWeight: 600,
                    color: "error.main",
                  }}
                />
              </ListItemButton>
            </Box>
          )}
        </Box>
      </Drawer>
    </>
  );
}

export default AdminNavBar;
